import { mapActions, mapGetters } from 'vuex';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'MyNumberCardPostpaidAccountBalance',

  props: {
    accountBalance: {
      type: String,
      required: true,
    },
    accountBalanceCurrent: {
      type: String,
      required: true,
    },
    interest: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      icons: {
        ballance: require("@/assets/wallet.svg"),
      }
    }
  },
  computed: {
    ...mapGetters(['subscriber']),
    shouldShowAccountBalance() {
      return parseFloat(this.accountBalance) > 0;
    },
  },
  methods: {
    ...mapActions(['genratePaymentToken']),
    goToPayments(price, paymentTitle) {
      const idTls = this.subscriber.id_tls;
      const title = `${paymentTitle} (id abonenta: ${idTls})`;
      const params = { price, title };
      this.genratePaymentToken(params);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/MyAccount/MyNumberCard/MyNumberCardPostpaidAccountBalance/component.js